"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.config.display.default.prompts.button': 'Non sai cosa chiedere? Prova i nostri suggerimenti!',
    'chat.config.button.label.text': 'Invia messaggio',
    'chat.config.cancel.button.label.text': 'Annulla generazione',
    'chat.config.voice.button.label.text': 'voice input',
    'chat.config.voice.rec.button.label.text': 'Ascolto input vocale',
    'chat.config.input.newline.helper': ' per nuova riga',
    'chat.config.autocomplete.styles.helper': ' per stili',
    'chat.config.autocomplete.projects.helper': ' per progetti',
    'chat.config.autocomplete.knowledge.helper': ' per conoscenza',
    'chat.config.live_chat.button.label.text': 'Live chat',
    'chat.config.input.placeholder': 'Digita la tua domanda, ad es. "Come posso aiutarti?"',
    'chat.config.user.is.bot': 'Assistente di supporto',
    'chat.config.reset.button.label.text': 'X',
    'chat.config.reset.button.title.text': 'Reimposta domanda corrente',
    'chat.config.reset.chat.button.title': 'Reimposta chat',
    'chat.config.copy.response.button.label.text': 'Copia risposta',
    'chat.config.copied.successfully.message': 'Risposta copiata!',
    'chat.config.follow.up.questions.label.text': 'Puoi anche chiedere...',
    'chat.config.show.thought.process.button.label.text': 'Mostra processo di pensiero',
    'chat.config.hide.thought.process.button.label.text': 'Nascondi processo di pensiero',
    'chat.config.loading.indicator.text': 'Attendere prego. Stiamo cercando e generando una risposta...',
    'chat.config.loading.text': 'Caricamento...',
    'chat.config.api.error.message': 'Siamo spiacenti, abbiamo alcuni problemi. Riprova più tardi.',
    'chat.config.invalid.request.error': 'Impossibile generare una risposta per questa query. Modifica la tua domanda e riprova.',
    'chat.config.thought.process.label': 'Processo di pensiero',
    'chat.config.support.context.label': 'Contesto di supporto',
    'chat.config.reasoning.label': 'Ragionamento',
    'chat.config.citations.label': 'Scopri di più:',
    'chat.config.citations.tab.label': 'Citazioni',
    'chat.config.branding.logo.alt': 'Logo del marchio',
    'chat.config.branding.headline': 'Benvenuto nell\'assistente di supporto del nostro marchio',
    'chat.config.show.chat.history.label': 'Mostra cronologia chat',
    'chat.config.hide.chat.history.label': 'Nascondi cronologia chat',
    'chat.config.chat.history.footer.text': 'Mostrando le ultime {MAX_CHAT_HISTORY} conversazioni',
    'chat.config.web.search.checkbox.label': 'Usa la ricerca web',
    'chat.config.deep.search.checkbox.label': 'Usa la ricerca approfondita',
    'chat.config.adv.prompt.checkbox.label': 'Prompting avanzato',
    'chat.config.autocomplete.style.selected': 'Stile "{name}" è stato aggiunto',
    'chat.config.autocomplete.project.selected': 'Progetto "{name}" è stato aggiunto',
    'chat.config.autocomplete.knowledge.selected': 'Conoscenza "{name}" è stata aggiunta',
    'chat.config.add.kdb.button.label.text': 'Aggiungi alla base di conoscenza',
};
